export type AppRoute =
  | { name: "kd-normative"; tab?: "instructions" | "standards" | "corpus" }
  | { name: "kd-sources" }
  | { name: "kd-materials" }
  | { name: "kd"; packageId?: string; tab?: "normative" }
  | { name: "chat"; conversationId?: string }
  | { name: "knowledge"; tab?: "cards" | "graph" | "imports" | "snapshots"; cardId?: string }
  | { name: "retrieval" }
  | { name: "users" };

function cleanHash(hash: string): string[] {
  return hash
    .replace(/^#\/?/, "")
    .split("/")
    .map(decodeURIComponent)
    .filter(Boolean);
}

export function parseRoute(hash: string): AppRoute {
  const parts = cleanHash(hash);
  if (parts[0] === "kd" && parts[1] === "materials") return { name: "kd-materials" };
  if (parts[0] === "kd" && parts[1] === "sources") return { name: "kd-sources" };
  if (parts[0] === "kd" && parts[1] === "normative") return { name: "kd-normative", tab: ["instructions", "standards", "corpus"].includes(parts[2] ?? "") ? parts[2] as "instructions" | "standards" | "corpus" : "instructions" };
  if (parts[0] === "kd") return { name: "kd", packageId: parts[1] };
  if (parts[0] === "knowledge") {
    if (parts[1] === "card" && parts[2]) {
      return { name: "knowledge", tab: "cards", cardId: parts[2] };
    }
    const tab = ["cards", "graph", "imports", "snapshots"].includes(parts[1] ?? "")
      ? (parts[1] as "cards" | "graph" | "imports" | "snapshots")
      : "cards";
    return { name: "knowledge", tab };
  }
  if (parts[0] === "retrieval") return { name: "retrieval" };
  if (parts[0] === "users") return { name: "users" };
  if (parts[0] === "chat" && parts[1]) {
    return { name: "chat", conversationId: parts[1] };
  }
  return { name: "chat" };
}

export function routeToHash(route: AppRoute): string {
  switch (route.name) {
    case "kd-normative": return `#/kd/normative/${route.tab ?? "instructions"}`;
    case "kd-materials": return "#/kd/materials";
    case "kd-sources": return "#/kd/sources";
    case "kd": return route.tab === "normative" ? "#/kd/normative" : route.packageId ? `#/kd/${encodeURIComponent(route.packageId)}` : "#/kd";
    case "knowledge":
      if (route.cardId) return `#/knowledge/card/${encodeURIComponent(route.cardId)}`;
      return `#/knowledge/${route.tab ?? "cards"}`;
    case "retrieval":
      return "#/retrieval";
    case "users":
      return "#/users";
    case "chat":
    default:
      return route.conversationId
        ? `#/chat/${encodeURIComponent(route.conversationId)}`
        : "#/chat";
  }
}
